import * as React from "react";
import { Stack } from "@mui/material";
import { Button } from "@mui/material";
import { Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} {...props} />;
});

//This for download button
export const CustomizedSnackbars = ({ btnText, downloadImg, downloadNoti }) => {
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <Stack sx={{ border: "none" }}>
      <Button onClick={handleClick}>
        <a href={downloadImg} download className="a-cv">
          <span className="a-qr-code">{btnText}</span>
        </a>
      </Button>
      <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          {downloadNoti}
        </Alert>
      </Snackbar>
    </Stack>
  );
};
